
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { mapInvoiceMain } from "@/redux/mappers/MasterMapper/MasterMapper";
export const esanchitApi = createApi({

    reducerPath: "esanchitApi",
    baseQuery,
    tagTypes: ["esanchit"],
    endpoints: (builder) => ({
        createESanchit: builder.mutation({
            query: ({ id, ...data }) => ({
              url: `/import/eSanchit/${id}`,
              method: "PUT",
              body: { eSanchit: data },
              headers: {
                "X-Request-Id": Math.random().toString(36).substring(2),
              },
            }),
            invalidatesTags: ["esanchit"],
          }),

          getEsanchitId: builder.query({
            query: ({id}) => `import/eSanchit/${id}`,
            transformResponse: (response) => 
              {
                const data= response?.data ?? [];
                const normalized = Array.isArray(data) ? data : [data];
                return normalized.map((item,index) => ({
                  ...item,
                  SrNo:index+1,
                  id: item.importeSanchitId, //  use backend's exportEntityId
                }));
    
              },
            providesTags: ["esanchit"],
          }),

          updateESanchit: builder.mutation({
            query: ({ id, subId, ...data }) => {
      
              return {
                url: `import/eSanchit/${id}/${subId}`,
                method: "PUT",
                body: { eSanchit: data },
                headers: {
                  "X-Request-Id": Math.random().toString(36).substring(2),
                },
              };
            },
            invalidatesTags: ["esanchit"],
          }),


          deleteESanchit: builder.mutation({
            query: ({ id }) => ({
              url: `import/eSanchit/${id}`,
              method: "DELETE",
              headers: {
                "X-Request-Id": Math.random().toString(36).substring(2),
              },
            }),
            invalidatesTags: ["esanchit"],
          }),

          getInvoiceMaster: builder.query({
            query: ({ id }) => `/import/invoice/main/${id}`,
            
            transformResponse: (response) => {
          
              return response?.data?.invoices?.map(mapInvoiceMain);
            },
          
            providesTags: ["InvoiceMaster"],
          }),

          // getFilterESanchit: builder.query({
          //   query: ({ id, data }) => {
          //     return `import/eSanchit/${id}?${data}`;
          //   },
          //   transformResponse: (response) => {
          //     console.log(response, "response checking in redux for filter");
          //     return response?.data?. [];
          //   },
          //   providesTags: ["eSanchit"],
          // }),

          getFilterESanchitImport: builder.query({
            query: ({id,data}) => `import/eSanchit/${id}?${data}`,
            transformResponse: (response) => 
              {
                const data= response?.data ?? [];
                const normalized = Array.isArray(data) ? data : [data];
                return normalized.map((item,index) => ({
                  ...item,
                  SrNo:index+1,
                  id: item.importeSanchitId, //  use backend's exportEntityId
                }));
    
              },
            providesTags: ["esanchit"],
          }),











        }),
    });
    export const {
        useCreateESanchitMutation,
        useLazyGetEsanchitIdQuery,
        useUpdateESanchitMutation,
        useDeleteESanchitMutation,
        useGetInvoiceMasterQuery,
        useLazyGetFilterESanchitImportQuery,

        
       
      } = esanchitApi;
